module.exports = __webpack_public_path__ + "img/steps.f6921b82.svg";